import React, { useEffect, useState, useRef } from "react";
import Seat from "./Seat";
import { rowsChartLaThanh_v5 } from "./rowsChartLaThanh_v5";
// import { rowsTableLaThanh_v5 } from "./rowsTableLaThanh_v5";
import * as XLSX from 'xlsx';

function Trang_v5({wkSheet}) {
  const [seats, setSeats] = useState([]);
  const [highlightColors, setHighlightColors] = useState(new Set());
  const [hoverSeat, setHoverSeat] = useState(null);
  const [groupSeatingChart, setGroupSeatingChart] = useState([]);

useEffect(() => {
    fetch("/chartSeat.xlsx") // lấy từ thư mục public
      .then((res) => res.arrayBuffer())
      .then((arrayBuffer) => {
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[wkSheet];
        const worksheet = workbook.Sheets[sheetName];
        const rawData = XLSX.utils.sheet_to_json(worksheet,{ header: 1 });
        // dạng mảng 2D
        const parsed = [];
        rawData.slice(1).forEach((row) => {// Bỏ dòng tiêu đề (row đầu tiên)
        const [labelGroup, colorGroup, ...positions] = row;
        if (labelGroup && colorGroup && positions.length > 0) {
          parsed.push({
            labelGroup: labelGroup.toString().trim(),
            colorGroup: colorGroup.toString().trim(),
            position: positions
              .filter(Boolean) // loại bỏ ô trống
              .map(p => p.toString().trim())
          });
        }
      });
      setGroupSeatingChart(parsed);
      // console.log(">> groupSeatingChart:", parsed);
      });
  }, []);


useEffect(() => {
    const seatPositionToColor = {};

    groupSeatingChart.forEach((group) => {
        const color = group.colorGroup; // lấy trực tiếp màu từ object
    
        group.position.forEach(pos => {
          seatPositionToColor[pos] = {
            color,
            labelGroup: group.labelGroup
          };
        });
      });

    // console.log("seatPositionToColor: ",seatPositionToColor);
//-------------------------------------------------------------------------------------
    const newSeats = [];
    
    rowsChartLaThanh_v5.forEach(({ labelRow, coordinates }) => {
      coordinates
        .sort((a, b) => b.cx - a.cx)//sắp xếp ngược từ phải sang trái
        .forEach((coor, index) => {
          const positionKey = `${labelRow}${index + 1}`;
          const config = seatPositionToColor[positionKey];
          newSeats.push({
            ...coor,
            seatNumber: index + 1,//bắt đầu đánh số từ 1
            color: config?.color || "#DDD",
            rowChar: labelRow,
            positionKey,
            labelGroup: config?.labelGroup || null
          });
        });
    });
    
    // console.log("Seats: ",newSeats);
//=======================================================================================
    setSeats(newSeats);
  }, [groupSeatingChart]);

  const handleClick = (seat) => {
    const newSet = new Set(highlightColors);
    if (newSet.has(seat.color)) {
      newSet.delete(seat.color);
    } else {
      newSet.add(seat.color);
    }
    setHighlightColors(newSet);
  };

  // nhóm seats theo rowChar
  const seatsByRow = {};
  seats.forEach((s) => {
    if (!seatsByRow[s.rowChar]) seatsByRow[s.rowChar] = [];
    seatsByRow[s.rowChar].push(s);
  });
  // console.log("seatsByRow: ", seatsByRow);
  
  const listDarkColor = new Set([
    "#000066",
    "#000099",
    "#0000CC",
    "#0000DD",
    "#0000FF",
    "#003300",
    "#003366",
    "#003399",
    "#0033CC",
    "#005500",
    "#006600",
    "#006633",
    "#006666",
    "#006699",
    "#0066CC",
    "#0066FF",
    "#008000",
    "#008080",
    "#009900",
    "#009999",
    "#0099CC",
    "#00CC00",
    "#333300",
    "#333399",
    "#3333CC",
    "#3333FF",
    "#336600",
    "#336633",
    "#336699",
    "#3366CC",
    "#3366FF",
    "#339933",
    "#339966",
    "#660033",
    "#660066",
    "#6600CC",
    "#6600FF",
    "#663300",
    "#663333",
    "#666600",
    "#666633",
    "#666699",
    "#6666FF",
    "#669900",
    "#669933",
    "#800000",
    "#800080",
    "#808000",
    "#833C0C",
    "#990000",
    "#990033",
    "#990066",
    "#990099",
    "#9900CC",
    "#9900FF",
    "#993300",
    "#993333",
    "#993366",
    "#9933FF",
    "#996600",
    "#996633",
    "#A50021",
    "#C00000",
    "#CC0000",
    "#CC0066",
    "#CC0099",
    "#CC00FF",
    "#CC3300",
    "#CC3333",
    "#CC3399",
    "#CC6600",
    "#D60093",
    "#FF0000",
    "#FF0066",
    "#FF3300"

  ]);
  
  // ---------------- Tooltip with accurate text width ----------------
  const [tooltipWidth, setTooltipWidth] = useState(0);
  const textRef = useRef(null);

  useEffect(() => {
    if (hoverSeat && textRef.current) {
      const len = textRef.current.getComputedTextLength();
      setTooltipWidth(len + 10); // padding
    }
  }, [hoverSeat]);

  return (
    <>
    <div style={{textAlign: 'center', width: '879.236px'}}>
        <h2 style={{marginBottom: 3, marginTop: 0}}>SƠ ĐỒ BỐ TRÍ CHỖ NGỒI</h2>
        <h4 style={{color: 'red', marginBottom: 5, marginTop: 0}}>Đại hội Thi đua yêu nước Hội Nông dân Việt Nam lần thứ VI,</h4>
        <h4 style={{color: 'red', marginBottom: 5, marginTop: 0}}>Lễ kỷ niệm 95 năm ngày thành lập Hội Nông dân Việt Nam</h4>
        <h5 style={{color: 'green', marginBottom: 5, marginTop: 0}}><i>Khách sạn La Thành, ngày 14 tháng 10 năm 2025</i></h5>
        <h6> ___ </h6>
      </div>
      
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="879.236px" height="912.856px"
        viewBox="0 0 879.236 912.856"
        style={{ enableBackground: "new 0 0 879.236 912.856" }}
        xmlSpace="preserve"
        onClick={() => setHighlightColors(new Set())} // click nền → reset
      >
        {/* trang trí */}
        <g>
          {/* bậc lên xuống */}
              <rect x="235.883" y="90.444" fill="#685151" width="11.529" height="26.353"/>
              <rect x="248.942" y="90.444" fill="#685151" width="11.529" height="26.353"/>
              <rect x="618.766" y="90.444" fill="#685151" width="11.529" height="26.353"/>
              <rect x="631.824" y="90.444" fill="#685151" width="11.529" height="26.353"/>
          {/* khung sân khấu */}
              <rect x="262.453" y="8.503" fill="#FFFFFF" stroke="#000000" strokeMiterlimit={10} width="354.33" height="136.063"/>
              <rect x="262.453" y="144.566" fill="#FFFFFF" stroke="#000000" strokeMiterlimit={10} width="354.33" height="14.173"/>
          {/* bục kỹ thuật */}
            <rect x="621.236" y="19.63" fill="#EE275F" width="30.117" height="47.146"/>
            <text transform="matrix(1 0 0 1 632.7246 40.3872)">
              <tspan x={0} y={0} fontFamily="'MyriadPro-Regular'" fontSize="6.551">KỸ</tspan>
              <tspan x="-6.037" y="7.861" fontFamily="'MyriadPro-Regular'" fontSize="6.551">THUẬT</tspan>
            </text>
          {/* đo khoảng cách đến sân khấu  */}
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="408.824" y1="244.266" x2="474.236" y2="244.266"/>
            <text transform="matrix(1 0 0 1 445.1665 205.6108)" fontFamily="'MyriadPro-Regular'" fontSize={9}> 3m </text>
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="441.53" y1="161.216" x2="441.53" y2="242.135"/>
            <polygon points="440.283,161.581 441.53,159.422 442.776,161.581"/>
            <polygon points="440.283,241.771 441.53,243.93 442.776,241.771"/>
          {/* đo khoảng cách 4 bàn  */}  
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="396.21" y1="225.637" x2="396.21" y2="234.637"/>
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="226.131" y1="225.637" x2="226.131" y2="234.637"/>
            <text transform="matrix(1 0 0 1 300.8735 222.7617)" fontFamily="'MyriadPro-Regular'" fontSize="10.7634"> 6 m </text>
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="227.925" y1="225.637" x2="394.416" y2="225.637"/>
            <polygon points="228.29,226.884 226.131,225.637 228.29,224.391"/>
            <polygon points="394.051,226.884 396.21,225.637 394.051,224.391"/>
          {/* 3 màn hình LED */}
            <rect x="101.295" y="-26.516" transform="matrix(0.5 0.866 -0.866 0.5 119.5155 -50.4649)" fill="#EE275F" width="4.333" height="209.576"/>
            <rect x="774.495" y="-26.516" transform="matrix(-0.4999 0.8661 -0.8661 -0.4999 1232.719 -555.2424)" fill="#EE275F" width="4.333" height="209.576"/>
            <rect x="274.609" y="10.972" fill="#EE275F" width="330.019" height="4.333"/>
          {/* đo khoảng cách 3 bàn  */} 
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="171.45" y1="223.087" x2="171.45" y2="237.087"/>
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="43.891" y1="223.087" x2="43.891" y2="237.087"/>
            <text transform="matrix(1 0 0 1 99.814 222.7617)" fontFamily="'MyriadPro-Regular'" fontSize="8.2001"> 4,5m </text>
            <line fill="none" stroke="#000000" strokeWidth="0.25" strokeMiterlimit={10} x1="45.685" y1="225.637" x2="169.656" y2="225.637"/>
            <polygon points="46.049,226.884 43.891,225.637 46.049,224.391"/>
            <polygon points="169.291,226.884 171.45,225.637 169.291,224.391"/>
          {/* 8 khu vực */}
          <text dy="0.7em" x="54.496" y="333.318" fontFamily="Arial" fontSize={190} opacity={0.17}> 1 </text>
          <text dy="0.7em" x="253.319" y="333.318" fontFamily="Arial" fontSize={190} opacity={0.17}> 2 </text>
          <text dy="0.7em" x="511.813" y="333.318" fontFamily="Arial" fontSize={190} opacity={0.17}> 3 </text>
          <text dy="0.7em" x="720.138" y="333.318" fontFamily="Arial" fontSize={190} opacity={0.17}> 4 </text>

          <text dy="0.7em" x="54.496" y="654.075" fontFamily="Arial" fontSize={190} opacity={0.17}> 8 </text>
          <text dy="0.7em" x="253.319" y="654.075" fontFamily="Arial" fontSize={190} opacity={0.17}> 7 </text>
          <text dy="0.7em" x="511.813" y="654.075" fontFamily="Arial" fontSize={190} opacity={0.17}> 6 </text>
          <text dy="0.7em" x="720.138" y="654.075" fontFamily="Arial" fontSize={190} opacity={0.17}> 5 </text>
          {/* cửa ra vào */}
          <polygon points="441.673,859.87 423.653,875.474 459.692,875.474" opacity="0.5"/>
          {/* bục phát biểu */}
          <rect x="551.901" y="102.091" transform="matrix(0.9887 0.1498 -0.1498 0.9887 23.1463 -83.6553)" fill="#ED2024" width="29.805" height="19.411">
          </rect>
                  {/* chữ quanh sân khấu */}
                  <text x="417.901" y="25.289" fontFamily="Tahoma" fontSize={8}> MÀN HÌNH LED </text>
                  <text x="399.364" y="85.258" fontFamily="Tahoma" fontSize={19}> SÂN KHẤU </text> {/* increase x 5 units, y 8 units */}
                  <text x="420.358" y="154.925" fontFamily="Tahoma" fontSize={9}> THẢM HOA </text> {/* increase y 6 units */}
                  <text x="106.329" y="94.195" fontFamily="Tahoma" fontSize={10}
                      transform="rotate(-30, 106.329, 94.195)"
                  > PANO </text> {/*97.329,94.195 increase x 9 units */}
                  <text x="755.021" y="83.893" fontFamily="Tahoma" fontSize={10}
                      transform="rotate(28, 755.021, 83.893)"
                  > PANO </text> {/*97.329,94.195 increase x 9 units */}
        </g>

        {/* Vẽ từng bàn */}
        {rowsChartLaThanh_v5.map(({ coordinates }, rowIndex) =>
          coordinates.map((coor, seatIndex) => (
            <rect
              key={`${rowIndex}-${seatIndex}`}
              x={coor.x}
              y={coor.y}
              stroke="#000"
              strokeWidth="0.5"
              fill={coor.fill}
              width="42.52"
              height={coor.height || 17.008}
            />
          ))
        )};

        {/* Vẽ từng ghế */}
        {seats.map((seat, idx) => {
          const isHighlighted = highlightColors.has(seat.color);
          return (
            <g
              key={idx}
              onClick={(e) => {
                e.stopPropagation(); // không cho click ghế lan ra svg
                handleClick(seat)
              }}
              onMouseEnter={() => setHoverSeat(seat)}
              onMouseLeave={() => setHoverSeat(null)}
            >
              <Seat
                key={idx}
                cx={seat.cx}
                cy={seat.cy}
                r="5.471"
                label={seat.seatNumber}
                fontSize = "7"
                fill={seat.color}
                stroke={isHighlighted ? "yellow" : "#333"}
                strokeWidth={isHighlighted ? 1 : 0.3}
                labelColor={listDarkColor.has(seat.color) ? "#fff" : "#000"} //ghế có đoàn thì chữ trắng, ko có đoàn thì chữ đen
               />
            </g>
          );
        })}

        {/* Vẽ ký hiệu hàng ghế (bên trái và phải) */}
        {Object.values(seatsByRow).map((rowSeats, i) => {
          const firstSeat = rowSeats[0];                      // ghế đầu tiên (trái)
          const lastSeat = rowSeats[rowSeats.length - 1];     // ghế cuối cùng (phải)
          const label = rowSeats[0].rowChar;

          // ❌ bỏ qua các label không cần hiển thị
          if (["SE", "VIPa", "VIPb", "VIPc", "N"].includes(label)) {
            return null;
          }

          return (
            <g key={`row-${i}`}>
              <text
                x={firstSeat.cx + 30 }//bên phải  + 30
                y={firstSeat.cy - 17 }//dịch lên trên
                fontSize="14"
                fontFamily="Tahoma"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="#000"
              >
                {label}
              </text>
              <text
                x={lastSeat.cx - 30 }//bên trái - 30
                y={lastSeat.cy - 17 }//
                fontSize="14"
                fontFamily="Tahoma"
                textAnchor="middle"
                dominantBaseline="middle"
                fill="#000"
              >
                {label}
              </text>
            </g>
          );
        })}

        {/* ✅ Tooltip chính xác theo độ dài thực tế */}
        {hoverSeat && (() => {
          const svgWidth = 879.236;
          const svgHeight = 912.856;
          const tooltipHeight = 20;

          const textContent = `Ghế ${hoverSeat.rowChar}${hoverSeat.seatNumber} ${
            hoverSeat.labelGroup
              ? hoverSeat.rowChar !== "A"
                ? `- đoàn ${hoverSeat.labelGroup}`
                : `- ${hoverSeat.labelGroup}`
              : "- ghế trống"
          }`;

          const rawX =
            hoverSeat.cx < svgWidth / 2
              ? hoverSeat.cx + 10
              : hoverSeat.cx - tooltipWidth - 10;

          const finalX = Math.max(0, Math.min(rawX, svgWidth - tooltipWidth));
          const rawY = hoverSeat.cy - 40;
          const finalY = Math.max(0, Math.min(rawY, svgHeight - tooltipHeight));

          const textX = finalX + 5;
          const textY = finalY + 15;

          return (
            <g>
              <rect
                x={finalX}
                y={finalY}
                width={tooltipWidth}
                height={tooltipHeight}
                fill="gray"
                rx="4"
              />
              <text
                ref={textRef}
                x={textX}
                y={textY}
                fontSize="12"
                fill="#fff"
              >
                {textContent}
              </text>
            </g>
          );
        })()}

      </svg>
      {/* <div  style={{width: '879.236px', fontSize: '11px'}}>
            <h4 style={{marginBottom: 3}}>GHI CHÚ:</h4>
            <p style={{marginTop: 0}}>-	Hàng A (28 ghế): Uỷ viên Bộ Chính trị; Uỷ viên Ban Bí thư; Uỷ viên Trung ương Đảng; Chủ tịch BCH TW Hội; Anh hùng LLVT; Các nguyên Chủ tịch BCH TW Hội; Các PCT BCH TW Hội.<br/>
            -	Hàng B, C, D (88 ghế): <br/>
            &nbsp;&nbsp;&nbsp;+	Đại biểu khách mời bộ, ngành (B1 - B15 và B22 - B36;C1 -C36; D1- D8 và D29- D36); <br/>
            &nbsp;&nbsp;&nbsp;+	Nhà tài trợ (B16-B17- B18); <br/>
            &nbsp;&nbsp;&nbsp;+	Trợ lý,Thư ký (B19-B20 - B21).<br/>
            -	Hàng D - khối 2, 3 (20 ghế): Đại biểu Trung ương Hội.<br/>
            -	Hàng E, F - khối 1, 4 (40 ghế): Đại biểu Hội Nông dân các tỉnh, thành phố.<br/>
            -	Hàng E, F - khối 2, 3 (40 ghế):Trưởng các đoàn đại biểu.<br/>
            -	Hàng G, H - khối 6, 7 (40 ghế): Đại biểu nhận bằng khen.<br/>
            -	Hàng G đến hàng L của khối 5, 8; Hàng I đến hàng L của khối 6, 7 (176 ghế): Đại biểu Hội Nông dân các tỉnh, thành phố.<br/>
            -	Hàng M - khối 5, 6, 7, 8 (36 ghế): Phóng viên, phục vụ, hậu cần...<br/>
            </p>
      </div> */}
      
    </>
  );
}

export default Trang_v5;
